"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import TestimonialCard from "../cards/TestimonialCard";
import { Team } from "@/app/data/TestimonialData";

// ✅ Required CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function Testimonial() {
  return (
    <div className="flex flex-col items-start justify-start w-full px-6 sm:px-10 lg:px-25 mx-auto py-10 sm:py-15 lg:py-20">
      {/* Top section */}
      <div className="flex flex-col lg:flex-row items-start justify-between w-full gap-6 lg:gap-0">

        <div className="flex flex-col w-full lg:w-3/4 gap-3 sm:gap-4">
            <h3 className="text-2xl sm:text-3xl lg:text-[40px] font-lora font-bold">
              What our happy farmers say
            </h3>
            <p className="text-base sm:text-lg leading-relaxed sm:leading-normal w-full lg:w-[65%]">
                Heartfelt experiences on the impact of shared dedication,
                resilient farming, and the community we continue to grow together.
            </p>
        </div>

        {/* Navigation buttons - Hidden on mobile, shown on desktop */}
        <div className="hidden lg:flex w-1/4 items-center justify-center relative h-40">
            <div className="flex items-start justify-end w-full h-full z-10 gap-6">
                <button className="swiper-button-prev border-2 border-accent px-8 py-6 hover:bg-accent hover:text-white transition-colors">
                    <ArrowLeft className="w-14 h-14 text-[20px] text-white" />
                </button>
                <button className="swiper-button-next bg-accent text-white border-2 border-accent px-8 py-6 hover:bg-accent transition-colors">
                    <ArrowRight className="w-14 h-14 text-[20px] text-white" />
                </button>
            </div> 
        </div>
      </div>

      {/* Swiper Slider */}
      <div className="flex items-center justify-center w-full pt-6 sm:pt-8 lg:pt-5">
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          spaceBetween={16}
          slidesPerView={1}
          pagination={{ 
            clickable: true,
            enabled: true,
          }}
          breakpoints={{
            640: { 
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: { 
              slidesPerView: 3,
              spaceBetween: 24,
              pagination: { enabled: false },
            },
            1280: { 
              slidesPerView: 4,
              spaceBetween: 10,
              pagination: { enabled: false },
            },
          }}
          className="w-full flex items-center justify-center"
        >
          {Team.map((member, idx) => (
            <SwiperSlide key={idx} className="flex justify-center pb-10 lg:pb-0">
                <TestimonialCard
                    testimonial={member.testimonial}
                    rating={member.rating}
                    user={member.user}
                    username={member.username}
                />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}